/* ================= language =================
   Language is now server-rendered per URL (/ = EN, /tr/ = TR).
   Toggle buttons are links; we only remember the choice and
   redirect first-time Turkish visitors landing on the EN home. */
(function(){
  var KEY='mirola-lang';
  document.querySelectorAll('.lang-btn[data-lang]').forEach(function(a){
    a.addEventListener('click',function(){ try{localStorage.setItem(KEY,a.dataset.lang);}catch(_){} });
  });
  var cur=document.documentElement.lang;
  var pref=null; try{pref=localStorage.getItem(KEY);}catch(_){}
  if(cur!=='tr' && location.pathname==='/' &&
     (pref==='tr' || (!pref && (navigator.language||'').toLowerCase().indexOf('tr')===0))){
    location.replace('/tr');
  }
})();

/* ================= nav ================= */
const navEl=document.getElementById('nav');
const navLinks=document.getElementById('navLinks'),navToggle=document.getElementById('navToggle'),navBackdrop=document.getElementById('navBackdrop');
function toggleMenu(){const open=navLinks.classList.toggle('open');navToggle.classList.toggle('open',open);navBackdrop.classList.toggle('open',open);}
function closeMenu(){navLinks.classList.remove('open');navToggle.classList.remove('open');navBackdrop.classList.remove('open');}
navLinks.querySelectorAll('a').forEach(a=>a.addEventListener('click',closeMenu));

/* ================= reveals ================= */
const obs=new IntersectionObserver((es)=>{
  let d=0;
  es.forEach((e)=>{
    if(e.isIntersecting){
      setTimeout(()=>e.target.classList.add('visible'),Math.min(d*60,240));
      d++; obs.unobserve(e.target);
    }
  });
},{threshold:.12,rootMargin:'0px 0px -6% 0px'});
document.querySelectorAll('.reveal').forEach(r=>obs.observe(r));

/* ================= exhibit image swap (blur crossfade) ================= */
document.querySelectorAll('.exhibit').forEach(ex=>{
  const imgs=[...ex.querySelectorAll('.ex-img')];
  const thumbs=[...ex.querySelectorAll('.ex-thumb')];
  let cur=0;
  function show(i){
    cur=i;
    imgs.forEach((im,k)=>im.classList.toggle('on',k===i));
    thumbs.forEach((t,k)=>t.classList.toggle('on',k===i));
  }
  thumbs.forEach(t=>t.addEventListener('click',()=>show(+t.dataset.i)));
  ex.__cur=()=>cur; ex.__imgs=imgs; ex.__name=ex.dataset.name;
  /* zoom → lightbox (current image) */
  let exCaps=[]; try{exCaps=JSON.parse(ex.dataset.caps||'[]');}catch(_){ }
  const open=()=>openLightboxEx(imgs,cur,ex.dataset.name,exCaps);
  ex.querySelector('[data-zoom]').addEventListener('click',open);
  const zb=ex.querySelector('[data-zoom-btn]'); if(zb) zb.addEventListener('click',open);
});

/* ================= lightbox ================= */
const lightbox=document.getElementById('lightbox'),lightboxImg=document.getElementById('lightboxImg'),lightboxCap=document.getElementById('lightboxCap'),lightboxCapText=document.getElementById('lightboxCapText');
let lbImgs=[],lbIdx=0,lbName='',lbCaps=[];
/* Caption line is optional: products without the custom.captions_* metafields
   pass no caps and the lightbox reads exactly as it did before. */
function lbShow(){const it=lbImgs[lbIdx];if(!it)return;lightboxImg.src=it.src;lightboxImg.alt=it.alt||'';lightboxCap.textContent=lbName+'  ·  '+(lbIdx+1)+'/'+lbImgs.length;const cap=lbCaps[lbIdx]||'';lightboxCapText.textContent=cap;lightboxCapText.hidden=!cap;}
function lbStep(d){if(lbImgs.length<2)return;lbIdx=(lbIdx+d+lbImgs.length)%lbImgs.length;lbShow();}
function openLightboxEx(imgs,start,name,caps){lbImgs=imgs.map(im=>({src:im.currentSrc||im.src,alt:im.alt}));lbIdx=start||0;lbName=name||'';lbCaps=Array.isArray(caps)?caps:[];lbShow();lightbox.classList.add('open');document.body.style.overflow='hidden';}
function closeLightbox(){lightbox.classList.remove('open');document.body.style.overflow='';}
lightbox.addEventListener('click',e=>{if(e.target===lightbox)closeLightbox();});
document.addEventListener('keydown',e=>{
  if(!lightbox.classList.contains('open'))return;
  if(e.key==='Escape')closeLightbox();
  else if(e.key==='ArrowLeft')lbStep(-1);
  else if(e.key==='ArrowRight')lbStep(1);
});

/* ================= commission form ================= */
/* Form posts natively to Shopify's contact endpoint (emails the store). */
/* On success the page reloads with a thank-you message rendered in Liquid. */
/* If a posted/error state is present, scroll back to the form so the message is seen. */
(function(){
  const cf=document.getElementById('commissionForm');
  if(cf && /[?&]contact_posted=/.test(location.search)){
    cf.scrollIntoView({behavior:'smooth',block:'center'});
  }
})();

/* ================= scroll: progress + nav + rail + spy ================= */
const progFill=document.getElementById('progFill');
const railFill=document.getElementById('railFill');
const procBody=document.getElementById('procBody');
const clamp=(v,a,b)=>Math.max(a,Math.min(b,v));
function update(){
  const vh=innerHeight;
  const total=document.documentElement.scrollHeight-vh;
  progFill.style.width=(total>0?(scrollY/total)*100:0)+'%';
  if(procBody){
    const pr=procBody.getBoundingClientRect();
    railFill.style.height=(clamp((vh*0.72-pr.top)/pr.height,0,1)*100)+'%';
  }
  navEl.classList.toggle('show',scrollY>vh*0.72);
}
window._update=update;
let ticking=false;
addEventListener('scroll',()=>{
  if(!ticking){requestAnimationFrame(()=>{ticking=false;update();});ticking=true;}
},{passive:true});
addEventListener('resize',update);
addEventListener('load',update);
update();

/* ================= modern micro-interactions ================= */
const FINE=matchMedia('(hover:hover) and (pointer:fine)').matches && !matchMedia('(prefers-reduced-motion: reduce)').matches;
if(FINE){
  /* entrance pointer glow */
  const ent=document.getElementById('entrance'), ptr=document.getElementById('entPointer');
  if(ent&&ptr) ent.addEventListener('pointermove',e=>{
    const r=ent.getBoundingClientRect();
    ptr.style.setProperty('--mx',((e.clientX-r.left)/r.width*100)+'%');
    ptr.style.setProperty('--my',((e.clientY-r.top)/r.height*100)+'%');
  });
  /* magnetic buttons */
  document.querySelectorAll('.btn-solid,.btn-stitch').forEach(b=>{
    b.addEventListener('pointermove',e=>{
      const r=b.getBoundingClientRect();
      const x=(e.clientX-r.left-r.width/2)*0.25, y=(e.clientY-r.top-r.height/2)*0.4;
      b.style.transform='translate('+x.toFixed(1)+'px,'+y.toFixed(1)+'px)';
    });
    b.addEventListener('pointerleave',()=>{b.style.transform='';});
  });
  /* frame 3D tilt */
  document.querySelectorAll('.ex-frame').forEach(f=>{
    f.addEventListener('pointermove',e=>{
      const r=f.getBoundingClientRect();
      const px=(e.clientX-r.left)/r.width-0.5, py=(e.clientY-r.top)/r.height-0.5;
      f.classList.add('tilt');
      f.style.transform='perspective(950px) rotateY('+(px*6).toFixed(2)+'deg) rotateX('+(-py*6).toFixed(2)+'deg)';
    });
    f.addEventListener('pointerleave',()=>{f.classList.remove('tilt');f.style.transform='';});
  });
}
